module.exports = __webpack_public_path__ + "static/scene-1.0d5817bf.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-1.png
// module id = 300
// module chunks = 2